const getters={
    GET_MENU:(state:any)=>state.sidebarMenu,
    GET_CURRENTMENU:(state:any)=>state.currentMenu,
    getCrumbList:(state:any)=>state.crumbList,
    getWorkTotal:(state:any)=>state.workTotal,
    getIsSidebarNavCollapse:(state:any)=>state.isSidebarNavCollapse,
}
export default getters